import { requestGet } from '@/common/request';
import { transformLevelAndHBHLevel } from '@/constants';

export default {
  async queryActivityAalendar(query) {
    const res = await requestGet('/home/calendar', query);

    if (res && res.ret === '0' && res.data) {
      // 将活动信息中的分格式化成元
      Object.values(res.data.calendarMap)
        .filter((item) => item)
        .forEach((activies) => {
          activies
            .filter((item) => item)
            .forEach((item) => {
              // 将分格式化成元
              if (item.dailySales) item.dailySales = item.dailySales / 100;
              // 将活动等级格式化
              const _item = transformLevelAndHBHLevel(item.level, item.otherLevel);
              Object.assign(item, _item);
            });
        });
    }
    return res;
  },
  queryResourceState(query) {
    return requestGet('/resourceState/query', query);
  },
};
